import { axiosApi } from "../../../../../../../api/dbAxios";

export const editTeamComments = async (
  regulatorCode: string | undefined,
  case_no: string | undefined,
  text: string | undefined,
  id: number,
) => {
  const test_email = "ykozak@deloittece.com";
  try {
    const isLocalhost =
      typeof window !== "undefined" && window.location.hostname === "localhost";
    const response = await axiosApi.patch(
      `/items/${regulatorCode}/${case_no}/comments/${id}/`,
      { text },
      {
        params: isLocalhost ? { test_email } : {},
      },
    );

    return response.data;
  } catch (error: any) {
    console.error("Error editing Team Comments:", error);
    throw error.response.data[0];
  }
};
